var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPushPinRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Glyph",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m58.58311 29.15034a5.79717 5.79717 0 0 1 -7.71 1.49005c-.68-.45-.68-.44-1.43.31995-3.67 3.72-4.68 4.72-7.74 7.75l-1.37 1.37c-.21723.19957-.25444.19246-.09.42005 3.9 5.87 1.42 12.45-2.21 16.65-1.84469 1.983-3.761 2.0151-5.7.23014-3.37152-3.38222-5.85822-5.79313-9.52-9.56012-.34928-.3044-.19914-.3607-.67 0q-4.32 3.54-8.66 7.04-2.61 2.115-5.24 4.24a3.17246 3.17246 0 0 1 -1.99.88 2.18174 2.18174 0 0 1 -1.55-.69c-1.4-1.37-.36-2.8.09-3.41 3.59735-4.92926 7.10522-9.83978 10.78-14.76.2661-.37146.22281-.279-.1-.62-3.3187-3.29-5.6203-5.59744-8.6-8.59-2.1107-2.09252-1.98943-4.20689.26-6.16 4.22-3.68 11.45-5.6 16.51-1.91.04.03.07.05.1.07 4.35842-4.40366 6.22109-6.26388 10.03-10.04a6.18943 6.18943 0 0 1 9.34989-8.05015c6.26008 6.20008 8.94007 8.89008 15.13007 15.13013a6.12135 6.12135 0 0 1 .33004 8.19995z",
    fill: "#de2c2f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPushPinRed);
export default __webpack_public_path__ + "static/media/icon-push-pin-red.c3d72ab652ee990f2bfb02ec2fbbad49.svg";
export { ForwardRef as ReactComponent };